import React from 'react';
import Avatar from 'components/Avatar/Avatar';
import { CPDPoints } from 'components/CPDPoints';
import constants from 'constants';

const {
  API_CERTIFICATES,
  CPD_STATUSES,
  SKIP_QUIZ_STATUS
} = constants;

const OnlineWebinar = ({
  webinar = {},
  startQuiz,
  token,
  userRole
}) => (
  <main className="site--width">
    <div className="container_player">
      <iframe src={`https://player.vimeo.com/video/${webinar.vimeo_url}` }width="920" height="180" frameBorder="0" webkitallowfullscreen mozallowfullscreen allowFullScreen></iframe>
    </div>
    <div className="container_info_player">
      <div className="title_video clearfix">
        <div className="player_time">
        </div>
        <h2>
          {webinar.webinar_title}
        </h2>
      </div>
      <div className="player_logo">
        <img src={webinar.sponsor ? webinar.sponsor.logo_url : ''} alt="logo"/>
          <div className="sponsor_logo_info clearfix">
            Sponsored by: {webinar.sponsor ? webinar.sponsor.title : 'N/A'}
          </div>
      </div>
      <div className="player_person clearfix-c">
        <div className="player_person_photo">
          <Avatar size={55} name={webinar.expert_name} src={webinar.doctor_avatar_url}/>
        </div>
        <div className="player_person_name">
          <p>{webinar.expert_name}</p>
        </div>
        <div className="player_person_description">
          <p>{`${webinar.doctor_type}`}・{webinar.work_location}</p>
        </div>

      </div>
      {takeQuiz(userRole, webinar, startQuiz, token)}
      <div className="current_points">
        <CPDPoints webinar={webinar} style={{ fontSize: '14px' }} />
      </div>
        <div className="webinar_status">
          {webinar && webinar.job_code_recorded_opened ? (<p>Job code: {webinar.job_code_recorded_opened}</p>):null}
          {/*<p>
            &nbsp; {webinar.is_quiz_completed && !webinar.joined && 'Already completed'}
            &nbsp; {webinar.joined && 'You were present at the webinar, so you do not need to pass the test.'}
          </p>*/}
        </div>
    </div>
  </main>
)

const takeQuiz = (userRole, webinar, startQuiz, token) => {
  if (userRole === "consultant" || userRole === "hospital_doctor") {
    return;
  }
  if (([SKIP_QUIZ_STATUS.available].indexOf(webinar.cpd_quiz)!==-1) && ([CPD_STATUSES.granted, CPD_STATUSES.applied_for].indexOf(webinar.cpd_status)!==-1) && (!(webinar.is_quiz_completed || webinar.joined))) {
    return (
      <div className="player_join">
        <div className="container_question">
          <a onClick={startQuiz}
            className="modal-trigger" href="javascript:void(0)">
            TAKE CPD QUIZ
          </a>
        </div>
      </div>
    )
  }
  if (webinar.cpd_status === CPD_STATUSES.granted) {
    return (
      <div className="player_download">
        <div className="container_download">
          <a href={`${API_CERTIFICATES}/${webinar.id}?token=${token}`}
             target="_blank"
          >
            <p className="section_live_download"></p>
          </a>
          <a href={`${API_CERTIFICATES}/${webinar.id}?token=${token}`}
             target="_blank"
          >
            <img src="/assets/img/grey-download.png" alt="icon"/>
          </a>
        </div>
      </div>
    )
  }
}

export default OnlineWebinar;



/** WEBPACK FOOTER **
 ** ./src/components/Webinar/OnlineWebinar.jsx
 **/